







































import Vue from 'vue';
import { MStoreInputType, Autocomplete } from '@/types';
import { FormFieldValidation } from '@/mixins/formValidation';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  name: 'MStoreFormInput',
  mixins: [FormFieldValidation],
  props: {
    autocomplete: {
      type: String,
      default: Autocomplete.off
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    lazyFormatter: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    placeholder: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: MStoreInputType.Text,
      validator: (val) => {
        return [MStoreInputType.Email, MStoreInputType.Password, MStoreInputType.Search, MStoreInputType.Text, MStoreInputType.Url, MStoreInputType.Number].indexOf(val) !== -1;
      }
    },
    value: {
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Object as () => ValidationModel
    },
    forceUpperCase: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    debounce: {
      type: Number,
      default: 0
    },
    hideValidationErrors: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputValue: {
      get(this: any) {
        return this.value;
      },
      set(this: any, value: string) {
        this.$emit('input', this.forceUpperCase ? value.toUpperCase() : value);
      }
    },
    fieldName(this: any) {
      return this.name || this.label;
    },
    minValue(this: any) {
      return this.validation?.minValue;
    },
    maxValue(this: any) {
      return this.validation?.maxValue;
    },
    isAutoComplete(this: any) {
      if (this.autocomplete === Autocomplete.on) {
        return this.autocomplete;
      } else if (this.type === MStoreInputType.Email) {
        return Autocomplete.nope;
      } else if (this.type === MStoreInputType.Password) {
        return Autocomplete.newPassword;
      } else {
        return Autocomplete.off;
      }
    },
    sizeAdjustedLabel(this: any) {
      return this.size === 'sm' ? '' : this.label;
    },
    sizeAdjustedPlaceHolder(this: any) {
      return this.placeholder ?? (this.size === 'sm' ? this.label : '');
    }
  },
  methods: {
    setDirty(this: any) {
      this.$refs.ValidationProvider.setFlags({ ...this.flags, dirty: true });
    },
    focus(this: any) {
      this.$refs.input.focus();
    }
  }
});
